import brandTheme from '../../Assets/Styles/brandTheme'

const {
  colors: { primary },
} = brandTheme()

export const style = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: "'Proxima Nova', sans-serif",
    height: '100%',
  },
  content: {
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'auto',
  },
  mainContent: {
    width: '100%',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0 24px',
    background: '#F9F9FF',
    border: '1px solid #E2E2FC',
    height: 50,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    cursor: 'pointer',
  },
  itemsWrapper: {
    padding: '20px 5px',
    border: '1px solid #DADBDA',
  },
  logoWrap: {
    display: 'flex',
    padding: '9px 16px',
    cursor: 'pointer',
    borderRadius: '12px',
  },
  active: {
    background: primary,
    width: '100%',
  },
  activeText: {
    color: '#FFFFFF !important',
  },
  nameWrap: {
    color: '#273754',
    fontWeight: '700',
    fontSize: '16px',
    marginLeft: '12px',
    lineHeight: '22px',
    paddingLeft: '10px',
  },
  link: {
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
    },
  },
  lineContainer: {
    display: 'flex',
    height: '30px',
    alignItems: 'center',
  },
  line: {
    border: '2px solid #DADBDA',
    borderRadius: '8px',
    width: '40px',
    margin: '0 auto',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '24px',
    '&:hover': {
      background: '#E2E2FC',
    },
    minWidth: '162px',
  },
  names: {
    marginLeft: '8px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  clientName: {
    color: '#011533',
    fontWeight: 'bold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontFeatureSettings: '"liga" off, "clig" off',
  },
  userName: {
    color: '#011533',
    fontWeight: 400,
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  userPicture: {
    borderRadius: '50%',
    overflow: 'hidden',
    height: '70px',
    width: '70px',
    '& img': {
      height: '70px',
      width: '70px',
      objectFit: 'cover',
      objectPosition: 'center',
    },
  },
  logoutContainer: {
    display: 'flex',
    padding: '16px',
    margin: '24px 5px 20px',
  },
  submenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '4px',
  },
  subItem: {
    display: 'flex',
    padding: '8px 0px 8px 48px',
    alignItems: 'center',
    fontSize: '16px',
    borderRadius: '8px',
    width: '100%',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: '#D1D1FA',
    },
  },
  subItemLink: {
    textDecoration: 'none !important',
    color: 'inherit',
    width: '100%',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:visited': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
    '&:active': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
  },
  subItemText: {
    color: '#273754',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  subItemActive: {
    background: '#E2E2FC',
    fontWeight: 500,
  },
}
